// src/cert/iso8124.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css';

const ISO8124 = () => {
  return (
    <div className="cert-page">
      <div className="cert-header">
        <h1>ISO 8124 प्रमाणन</h1>
        <p>खेळण्यांची सुरक्षा (Safety of Toys)</p>
      </div>

      <div className="cert-content">
        <section>
          <h2>ISO 8124 म्हणजे काय?</h2>
          <p>
            ISO 8124 ही <strong>खेळण्यांसाठी आंतरराष्ट्रीय सुरक्षा मानक</strong> आहे जी 
            <strong>3 ते 14 वर्षे वयोगटातील मुलांसाठी</strong> 
            <strong>यांत्रिक, भौतिक, रासायनिक आणि ज्वलनशीलता</strong> जोखीम कमी करते. 
            ही <strong>EN 71 (युरोप), ASTM F963 (USA)</strong> सारख्या मानकांशी सुसंगत आहे.
          </p>
        </section>

        <section>
          <h2>प्रमुख फायदे</h2>
          <ul>
            <li>मुलांचे दुखापत, गुदमरणे, विषबाधा टाळता येतात</li>
            <li>EU, USA, कॅनडा, ऑस्ट्रेलियामध्ये खेळणी विक्री कायदेशीर होते</li>
            <li>CE Marking, CPSIA अनुपालनासाठी आवश्यक</li>
            <li>रासायनिक चाचणी (Lead, Phthalates), यांत्रिक चाचणी (Sharp Edges, Small Parts)</li>
            <li>ब्रँड प्रतिष्ठा आणि ग्राहकांचा विश्वास वाढतो</li>
          </ul>
        </section>

        <section className="apply-section">
          <h2>ISO 8124 साठी अर्ज करा</h2>
          <ApplyForm certification="ISO 8124" />
        </section>
      </div>
    </div>
  );
};

export default ISO8124;